/* --- TONI: Patch robusto para media-gallery.setActiveMedia (normaliza IDs y usa el scroller correcto) --- */
(function toniInstallSetActiveMediaPatch(){
  const tryInstall = () => {
    const mg = document.querySelector('media-gallery');
    if (!mg || typeof mg.setActiveMedia !== 'function') return false;
    if (mg.__TONI_patched_setActiveMedia) return true;

    const getViewer = () => mg.elements?.viewer || document;
    const getThumbs = () => mg.elements?.thumbnails || document;

    const toPrefixed = (id) => {
      const strId = String(id || '');
      if (strId && /__main-\d+$/.test(strId)) return strId;
      const slide = getViewer().querySelector(`[data-media-id$="-${CSS.escape(strId)}"]`);
      return slide?.dataset?.mediaId || strId;
    };

    const findSlideLI = (mediaId) => {
      const viewer = getViewer();
      let el = viewer.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`) ||
               viewer.querySelector(`[data-media-id$="-${CSS.escape(String(mediaId))}"]`);
      if (!el) return null;
      return el.closest?.('.product__media-item') || el;
    };

    const findViewerScroller = (el) => {
      let sc = el;
      while (sc && sc !== document.body) {
        const st = getComputedStyle(sc);
        if ((sc.scrollWidth > sc.clientWidth) && /(auto|scroll|overlay)/.test(st.overflowX || st.overflow)) return sc;
        sc = sc.parentElement;
      }
      return null;
    };

    const original = mg.setActiveMedia.bind(mg);

    mg.setActiveMedia = function patchedSetActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      try {
        const viewer = getViewer();
        const thumbs = getThumbs();

        const prefixed = toPrefixed(mediaId);
        const targetLI = findSlideLI(prefixed) || findSlideLI(mediaId);
        if (!targetLI) {
          console.warn('[TONI PATCH] slide no encontrada para', mediaId, '→', prefixed);
          return;
        }

        viewer.querySelectorAll('.product__media-item.is-active').forEach(n => n.classList.remove('is-active'));
        targetLI.classList.add('is-active');

        const scroller = findViewerScroller(targetLI) || targetLI.parentElement;
        if (scroller?.scrollTo) {
          const x = targetLI.offsetLeft - (scroller.clientLeft || 0);
          scroller.scrollTo({ left: x, behavior: 'instant' });
          requestAnimationFrame(() => scroller.scrollTo({ left: x, behavior: 'smooth' }));
        } else {
          targetLI.scrollIntoView?.({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        if (thumbs) {
          const liThumb =
            thumbs.querySelector(`.thumbnail-list__item[data-target="${CSS.escape(prefixed)}"]`) ||
            thumbs.querySelector(`.thumbnail-list__item[data-target$="-${CSS.escape(String(mediaId))}"]`) ||
            null;
          try { this.setActiveThumbnail?.(liThumb ? (liThumb.querySelector('button') || liThumb) : null); } catch {}
          try {
            const pos = liThumb?.dataset?.mediaPosition || '';
            this.announceLiveRegion?.(targetLI, pos);
          } catch {}
        }

        try { this.playActiveMedia?.(targetLI); } catch {}

        if (filtering && currentVariant) {
          this.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach(slide => {
            if (slide.dataset.alt === currentVariant[this.filteringOption]) slide.classList.remove('hidden');
            else slide.classList.add('hidden');
          });
        }
      } catch (e) {
        console.error('[TONI PATCH] setActiveMedia error → fallback al original', e);
        try { return original(mediaId, prepend, filtering, currentVariant); } catch {}
      }
    };

    Object.defineProperty(mg, '__TONI_patched_setActiveMedia', { value: true, configurable: false });
    console.info('[TONI PATCH] setActiveMedia normalizado ✓');
    return true;
  };

  if (!tryInstall()) {
    const mo = new MutationObserver(() => { if (tryInstall()) { try { mo.disconnect(); } catch {} } });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', () => { tryInstall(); }, { once: true });
  }
})();

/* ======================= TU CÓDIGO ORIGINAL (sin eliminar nada) ======================= */

// Toni Logic v4 — fuerza la variante correcta en todos los formularios ATC
document.addEventListener('DOMContentLoaded', () => {
  console.log('Toni Logic v4: activo');

  // -------- helpers de formularios ----------
  const getATCForms = () => [...document.querySelectorAll('form[action*="/cart/add"]')];

  const ensureHiddenVariantInput = (form) => {
    let inp = form.querySelector('input[name="id"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'id';
      form.appendChild(inp);
    }
    return inp;
  };

  const setVariantEverywhere = (variantId) => {
    getATCForms().forEach((form) => {
      const inp = ensureHiddenVariantInput(form);
      if (String(inp.value) !== String(variantId)) {
        inp.value = variantId;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    const url = new URL(location.href);
    if (url.searchParams.get('variant') !== String(variantId)) {
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }
  };

  // -------- helpers de variantes ----------
  const getVariantSelects = () => [...document.querySelectorAll('variant-selects')];

  const getVariantsJSONFromContainer = (container) => {
    const node = container.querySelector('script[type="application/json"]');
    if (!node || !node.textContent) return null;
    try { return JSON.parse(node.textContent); } catch { return null; }
  };

  const getOrderedOptionNames = (container) => {
    const names = [];
    const groups = container.querySelectorAll('.product-form__input');
    groups.forEach((g) => {
      const el =
        g.querySelector('[name^="options["]') ||
        g.querySelector('select[name^="options["]') ||
        g.querySelector('input[name^="options["]');
      if (!el) return;
      const m = el.name.match(/^options\[(.+)\]$/);
      if (m && m[1]) names.push(m[1]);
    });
    return names;
  };

  const getSelectedOptionsInContainer = (container, optionNames) => {
    const values = [];
    optionNames.forEach((name, idx) => {
      const selector = `[name="options[${CSS.escape(name)}]"]`;
      const checked = container.querySelector(`${selector}[type="radio"]:checked`);
      if (checked) { values[idx] = checked.value; return; }
      const select = container.querySelector(`select${selector}`);
      if (select) { values[idx] = select.value; return; }
      const any = container.querySelector(selector);
      if (any && any.value) { values[idx] = any.value; return; }
      values[idx] = null;
    });
    return values;
  };

  const findVariantByOptions = (variants, orderedValues) => {
    if (!Array.isArray(variants) || !variants.length) return null;
    return variants.find(v =>
      (orderedValues[0] == null || v.option1 === orderedValues[0]) &&
      (orderedValues[1] == null || v.option2 === orderedValues[1]) &&
      (orderedValues[2] == null || v.option3 === orderedValues[2])
    ) || null;
  };

  const recomputeFromContainer = (container) => {
    const variants = getVariantsJSONFromContainer(container);
    if (!variants) { console.debug('Toni Logic v4: sin JSON de variantes'); return; }
    const optionNames = getOrderedOptionNames(container);
    const selected = getSelectedOptionsInContainer(container, optionNames);
    const v = findVariantByOptions(variants, selected);
    if (v && v.id) {
      setVariantEverywhere(v.id);
      try { window.__TONI_switchMainImageTo && window.__TONI_switchMainImageTo(v); } catch(e) {}
      const detail = { variant: v, selectedVariant: v, productVariant: v };
      document.dispatchEvent(new CustomEvent('variant:change', { detail, bubbles: true }));
      document.dispatchEvent(new CustomEvent('variants:change', { detail, bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:changed', { detail, bubbles: true }));
      document.dispatchEvent(new CustomEvent('product:variant-change', { detail, bubbles: true }));
    } else {
      console.debug('Toni Logic v4: no se encontró variante para', selected);
    }
  };

  getVariantSelects().forEach((vs) => {
    vs.addEventListener('change', (e) => {
      if (!(e.target && e.target.name && e.target.name.startsWith('options['))) return;
      recomputeFromContainer(vs);
    });
    recomputeFromContainer(vs);
  });

  getATCForms().forEach((form) => {
    form.addEventListener('submit', (e) => {
      const vs = getVariantSelects()[0] || document;
      if (vs && vs.tagName && vs.tagName.toLowerCase() === 'variant-selects') {
        recomputeFromContainer(vs);
      }
    }, true);
  });

  document.addEventListener('click', (e) => {
    const isOption = e.target && (
      e.target.matches('[name^="options["]') ||
      e.target.closest('.color-swatch') ||
      e.target.closest('.variant-pills') ||
      e.target.closest('.product-form__input') ||
      (e.target.matches('label') && e.target.getAttribute('for') && e.target.getAttribute('for').includes('-'))
    );
    if (!isOption) return;
    requestAnimationFrame(() => {
      const vs = document.querySelector('variant-selects');
      if (vs) { try { recomputeFromContainer(vs); } catch(e) {} }
    });
  }, true);

  const setupObserver = () => {
    const vs = document.querySelector('variant-selects');
    if (!vs) return;
    const mo = new MutationObserver(() => {
      try { recomputeFromContainer(vs); } catch(e) {}
    });
    mo.observe(vs, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked','aria-checked','class','value'] });
  };
  setupObserver();
});

// --- Toni Logic: cambiar imagen principal SIN abrir el modal (v2) ---
(function(){
  const getVariantMediaId = (variant) => {
    if (variant?.featured_media?.id) return String(variant.featured_media.id);
    if (variant?.featured_image?.id) return String(variant.featured_image.id);
    return null;
  };
  const forceImageInContainer = (container, url) => {
    if (!container || !url) return false;
    const img = container.querySelector('img');
    if (img) {
      if (img.srcset) img.srcset = '';
      img.src = url;
    }
    const sources = container.querySelectorAll('source');
    if (sources && sources.length) {
      sources.forEach(s => {
        if (s.hasAttribute('data-srcset')) s.setAttribute('data-srcset', url);
        s.setAttribute('srcset', url);
      });
    }
    return !!img || (sources && sources.length > 0);
  };
  const switchMainImageTo = (variant) => {
    const mediaId = getVariantMediaId(variant);
    const mg = document.querySelector('media-gallery');
    if (mg && typeof mg.setActiveMedia === 'function' && mediaId) {
      try {
        mg.setActiveMedia(String(mediaId), true);
        return;
      } catch(e) {}
    }
    if (mediaId) {
      const thumbSelector = `[data-media-id="${CSS.escape(String(mediaId))}"]`;
      const allThumbs = document.querySelectorAll(thumbSelector);
      if (allThumbs.length) {
        document.querySelectorAll('[data-media-id][aria-current="true"]').forEach(el => el.setAttribute('aria-current', 'false'));
        document.querySelectorAll('.is-active').forEach(el => el.classList.remove('is-active'));
        const t = allThumbs[0];
        t.setAttribute('aria-current', 'true');
        t.classList.add('is-active');
      }
      const slide =
        document.querySelector(`#Slide-${CSS.escape(String(mediaId))}`) ||
        document.querySelector(`.product__media-item[data-media-id="${CSS.escape(String(mediaId))}"]`) ||
        document.querySelector(`.swiper-slide[data-media-id="${CSS.escape(String(mediaId))}"]`) ||
        document.querySelector(`.slick-slide[data-media-id="${CSS.escape(String(mediaId))}"]`);
      if (slide) {
        const activeSel = ['.is-active', '[aria-current="true"]'];
        activeSel.forEach(sel => slide.parentElement?.querySelectorAll(sel).forEach(el => {
          if (el !== slide) {
            el.classList?.remove('is-active');
            el.setAttribute?.('aria-current', 'false');
          }
        }));
        slide.classList.add('is-active');
        slide.setAttribute?.('aria-current', 'true');
        if (variant?.featured_image?.src) {
          forceImageInContainer(slide, variant.featured_image.src);
        }
        slide.scrollIntoView?.({ behavior: 'instant', block: 'nearest', inline: 'center' });
        return;
      }
    }
    if (variant?.featured_image?.src) {
      const candidates = [
        document.querySelector('media-gallery [data-media-id][aria-current="true"]'),
        document.querySelector('media-gallery .is-active'),
        document.querySelector('[data-product-image]'),
        document.querySelector('.product__media'),
        document.querySelector('.product-media'),
        document.querySelector('.product__media-item'),
        document.querySelector('.product-gallery')
      ].filter(Boolean);
      let replaced = false;
      for (const c of candidates) {
        if (forceImageInContainer(c, variant.featured_image.src)) { replaced = true; break; }
      }
      if (!replaced) {
        const anyImg =
          document.querySelector('media-gallery img') ||
          document.querySelector('.product__media img') ||
          document.querySelector('.product-media img') ||
          document.querySelector('.product__media-item img') ||
          document.querySelector('.product-gallery img');
        if (anyImg) {
          if (anyImg.srcset) anyImg.srcset = '';
          anyImg.src = variant.featured_image.src;
        }
      }
    }
  };
  window.__TONI_switchMainImageTo = switchMainImageTo;
  const handleVariantEvent = (e) => {
    const v = e.detail && (e.detail.variant || e.detail.selectedVariant || e.detail.productVariant);
    if (v) switchMainImageTo(v);
  };
  document.addEventListener('variant:change', handleVariantEvent);
  document.addEventListener('variants:change', handleVariantEvent);
  document.addEventListener('variant:changed', handleVariantEvent);
  document.addEventListener('product:variant-change', handleVariantEvent);
})();


/* Toni Pack Handler v1 — añade correctamente 2/3 piezas */
/* Toni Pack Handler v1 — añade correctamente 2/3 piezas (versión robusta para "Prendi 1 + 1 GRATIS") */
(() => {
  const log = (...a)=>console.log('[TONI PACK]', ...a);

  // helpers para localizar el bloque de variantes y el de quantity breaks
  const getVS = () => document.querySelector('variant-selects');
  const getQB = () => document.querySelector('.quantity-breaks,[data-quantity-breaks]');

  const getVariants = (vs) => {
    const n = vs?.querySelector('script[type="application/json"]');
    if (!n?.textContent) return null;
    try { return JSON.parse(n.textContent); } catch { return null; }
  };

  const getOptionNames = (vs) => {
    const names = [];
    vs?.querySelectorAll('.product-form__input').forEach(g => {
      const el = g.querySelector('[name^="options["]'); // radios o select
      const m = el?.name?.match(/^options\[(.+)\]$/);
      if (m?.[1]) names.push(m[1]);
    });
    return names;
  };

  const isColorName = n => /color|colou?r|colore|couleur|farbe/i.test(n||'');
  const isSizeName  = n => /size|talla|taglia|misur|taille/i.test(n||'');

  // lee las opciones actualmente marcadas en el bloque principal
  const baseSelectedValues = (vs, optionNames) =>
    optionNames.map(n =>
      vs.querySelector(`[name="options[${CSS.escape(n)}]"][type="radio"]:checked`)?.value ||
      vs.querySelector(`select[name="options[${CSS.escape(n)}]"]`)?.value ||
      vs.querySelector(`[name="options[${CSS.escape(n)}]"]`)?.value ||
      null
    );

  const findVariant = (variants, vals) =>
    variants.find(v =>
      (vals[0]==null || v.option1===vals[0]) &&
      (vals[1]==null || v.option2===vals[1]) &&
      (vals[2]==null || v.option3===vals[2])
    );

  // 👇 AQUÍ estaba el problema: antes solo mirabas "2 pezzi / pieces / pcs"
  const resolvePackIds = () => {
    const vs = getVS();
    const qb = getQB();
    if (!vs || !qb) return null;

    const variants    = getVariants(vs);
    const optionNames = getOptionNames(vs);
    if (!variants?.length || !optionNames.length) return null;

    const colorName = optionNames.find(isColorName) || optionNames[0];
    const sizeName  = optionNames.find(isSizeName)  || optionNames[1];

    const baseVals  = baseSelectedValues(vs, optionNames);

    // tarjeta / radio activo del quantity break
    const activeRadio =
      qb.querySelector('input[type="radio"]:checked') ||
      qb.querySelector('input[type="radio"][checked]');
    if (!activeRadio) return null;

    const activeCard =
      document.querySelector(`label.quantity-break[for="${activeRadio.id}"]`) ||
      activeRadio.closest('.quantity-break') ||
      activeRadio.parentElement;

    const tierTextRaw = (activeCard?.innerText || '').trim();
    const tierText    = tierTextRaw.replace(/\s+/g, ' '); // normaliza espacios

    // todos los selects dentro de esa tarjeta (suelen ser 4 en 1+1)
    const selects = [...activeCard.querySelectorAll('select')].filter(s => !s.disabled);

    // 1) detección por texto (nuevo)
    const looksLikePackByText =
      /(2|3)\s*(pezzi|pieces|pcs|prodotti?)/i.test(tierText) ||   // "2 pezzi", "2 prodotti"
      /1\s*\+\s*1/i.test(tierText) ||                             // "1 + 1", "1+1"
      /1x1|2x1/i.test(tierText) ||                                // "1x1", "2x1"
      /prendi\s*1\s*\+\s*1/i.test(tierText);                      // "Prendi 1 + 1 ..."

    // 2) detección por estructura (fallback): si hay >=4 selects, casi seguro es pack 1+1
    const looksLikePackBySelects = selects.length >= 4;

    const isPack = looksLikePackByText || looksLikePackBySelects;
    if (!isPack) return null;

    // cada par de selects = un producto (color + talla)
    const pairCount = Math.floor(selects.length / 2);
    if (pairCount < 2) return null;

    const ids = [];

    for (let i = 0; i < pairCount; i++) {
      const a = selects[i*2];
      const b = selects[i*2 + 1];

      let colorVal, sizeVal;

      // intentamos asignar quién es color y quién talla
      if (isColorName(a?.name) || isSizeName(b?.name)) {
        colorVal = a?.value;
        sizeVal  = b?.value;
      } else if (isColorName(b?.name) || isSizeName(a?.name)) {
        colorVal = b?.value;
        sizeVal  = a?.value;
      } else {
        // si el tema no nombra bien los selects, asumimos a = color, b = talla
        colorVal = a?.value;
        sizeVal  = b?.value;
      }

      // clonamos las opciones base y metemos las de este producto del pack
      const vals = [...baseVals];

      const ci = optionNames.indexOf(colorName);
      if (ci > -1) vals[ci] = colorVal ?? vals[ci];

      const si = optionNames.indexOf(sizeName);
      if (si > -1) vals[si] = sizeVal ?? vals[si];

      const v = findVariant(variants, vals);
      if (v?.id) ids.push(String(v.id));
    }

    return ids.length >= 2 ? ids : null;
  };

  // añade varios productos de golpe
  const addMultiple = async (ids) => {
    const payload = { items: ids.map(id => ({ id, quantity: 1 })) };
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!r.ok) throw new Error('cart/add.js falló');
    return r.json();
  };

  // hookea los formularios ATC
  const hookForms = () => {
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
    forms.forEach(form => {
      if (form.dataset.toniPackHooked) return;
      form.dataset.toniPackHooked = '1';

      form.addEventListener('submit', async (ev) => {
        try {
          const ids = resolvePackIds();
          // si no es pack → dejamos que Shopify haga lo suyo
          if (!ids) return;

          // si sí es pack → frenamos envío normal y mandamos los 2/3 items
          ev.preventDefault();
          ev.stopImmediatePropagation();

          log('IDs pack detectados:', ids);
          await addMultiple(ids);

          // fuerza refresco del carrito / drawer
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
          document.querySelector('[data-cart-drawer-open]')?.click?.();

          // si no hay drawer, redirigimos
          setTimeout(() => {
            if (!document.body.classList.contains('cart-drawer-open')) {
              window.location.href = '/cart';
            }
          }, 400);
        } catch (e) {
          console.error('[TONI PACK] Error añadiendo pack:', e);
        }
      }, true);
    });
  };

  hookForms();
  new MutationObserver(hookForms).observe(document.documentElement, { childList:true, subtree:true });
})();


/* ==== TONI: swatches de color solo imagen (sustituye el texto por miniatura) ==== */
(function () {
  const COLOR_RE = /color|colou?r|colore|couleur|farbe/i;
  function injectStylesOnce() {
    if (document.getElementById('toni-swatch-img-only-styles')) return;
    const style = document.createElement('style');
    style.id = 'toni-swatch-img-only-styles';
    style.textContent = `
      .toni-sr-only{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}
      .toni-swatch-img-label{
        position: relative;
        overflow: hidden;
        color: transparent!important;
        text-shadow: none!important;
      }
      .toni-swatch-img-label::after{
        content:"";
        position:absolute;inset:0;
        background-position:center;
        background-repeat:no-repeat;
        background-size:cover;
        transition:transform .15s ease;
      }
      .toni-swatch-img-label.toni-selected{box-shadow:0 0 0 2px rgba(0,0,0,.35) inset}
      .toni-swatch-img-label:hover::after{transform:scale(1.02)}
      .toni-swatch-img-btn{
        display:inline-block;vertical-align:top;margin:6px 8px 0 0;
        width:112px;height:112px;border-radius:999px;border:3px solid rgba(0,0,0,.2);
        background-size:cover;background-position:center;background-repeat:no-repeat;
        cursor:pointer;position:relative;overflow:hidden;padding:0;
      }
      .toni-swatch-img-btn[aria-pressed="true"]{box-shadow:0 0 0 2px rgba(0,0,0,.35) inset}
    `;
    document.head.appendChild(style);
  }
  document.addEventListener('DOMContentLoaded', () => {
    const vs = document.querySelector('variant-selects');
    if (!vs) return;
    injectStylesOnce();
    const scriptNode = vs.querySelector('script[type="application/json"]');
    let variants = [];
    try { variants = JSON.parse(scriptNode?.textContent || '[]'); } catch (_) {}
    const groups = [...vs.querySelectorAll('.product-form__input')];
    let colorName = null;
    let colorIdx = -1;
    groups.forEach((g, idx) => {
      const el = g.querySelector('[name^="options["]');
      const m = el && el.name && el.name.match(/^options\[(.+)\]$/);
      if (m && COLOR_RE.test(m[1]) && colorName === null) { colorName = m[1]; colorIdx = idx; }
    });
    if (!colorName) return;
    const colorToSrc = {};
    variants.forEach(v => {
      const opt = [v.option1, v.option2, v.option3][colorIdx];
      const src =
        v?.featured_image?.src ||
        v?.featured_media?.preview_image?.src ||
        v?.featured_media?.src ||
        null;
      if (opt && src && !colorToSrc[opt]) colorToSrc[opt] = src;
    });
    const radios = vs.querySelectorAll(`input[type="radio"][name="options[${CSS.escape(colorName)}]"]`);
    if (radios.length) {
      radios.forEach(r => {
        const lab = vs.querySelector(`label[for="${r.id}"]`);
        if (!lab || lab.dataset.toniImgOnly === '1') return;
        lab.dataset.toniImgOnly = '1';
        const src = colorToSrc[r.value];
        const originalText = (lab.textContent || r.value || '').trim();
        lab.classList.add('toni-swatch-img-label');
        const h = parseFloat(getComputedStyle(lab).height) || 48;
        lab.style.height = (h * 2) + 'px';
        lab.style.width  = (h * 2) + 'px';
        lab.style.padding = '0';
        lab.style.borderRadius = getComputedStyle(lab).borderRadius || '999px';
        const sr = document.createElement('span');
        sr.className = 'toni-sr-only';
        sr.textContent = originalText;
        while (lab.firstChild) lab.removeChild(lab.firstChild);
        lab.appendChild(sr);
        if (src) lab.style.setProperty('--toni-swatch-img', `url("${src}")`);
        lab.style.setProperty('--toni-swatch-img', lab.style.getPropertyValue('--toni-swatch-img') || '');
        lab.style.setProperty('--toni-swatch-bg', src ? `url("${src}")` : 'none');
        lab.style.position = 'relative';
        lab.style.background = 'none';
        lab.style.setProperty('--bg', src ? `url("${src}")` : 'none');
        lab.style.setProperty('--bg-size', 'cover');
        lab.style.setProperty('--bg-pos', 'center');
        lab.style.setProperty('--bg-repeat', 'no-repeat');
        lab.style.setProperty('background-image', 'none');
        lab.style.setProperty('background-color', 'transparent');
        lab.style.setProperty('overflow', 'hidden');
        lab.style.setProperty('--_img', src ? `url("${src}")` : 'none');
        const setBg = () => { lab.style.setProperty('--_img', src ? `url("${src}")` : 'none'); };
        setBg();
        lab.style.setProperty('position', 'relative');
        lab.style.setProperty('isolation', 'isolate');
        lab.style.setProperty('contain', 'layout paint');
        lab.style.setProperty('background', 'transparent');
        lab.style.setProperty('border', getComputedStyle(lab).border || '1px solid rgba(0,0,0,.2)');
        const id = 'toni-bg-' + r.id;
        lab.dataset.bgTarget = id;
        const observer = new MutationObserver(() => {
          const checked = r.checked;
          lab.classList.toggle('toni-selected', !!checked);
        });
        observer.observe(r, { attributes: true, attributeFilter: ['checked', 'aria-checked'] });
        const styleEl = document.createElement('style');
        styleEl.textContent = `
          label[for="${CSS.escape(r.id)}"].toni-swatch-img-label::after{
            background-image: ${src ? `url("${src}")` : 'none'};
          }
        `;
        document.head.appendChild(styleEl);
      });
      const sync = () => {
        radios.forEach(r => {
          const lab = vs.querySelector(`label[for="${r.id}"]`);
          if (lab) lab.classList.toggle('toni-selected', r.checked);
        });
      };
      sync();
      vs.addEventListener('change', (e) => {
        if (e.target && e.target.name === `options[${colorName}]`) sync();
      });
      return;
    }
    const select = vs.querySelector(`select[name="options[${CSS.escape(colorName)}]"]`);
    if (select && !select.dataset.toniImgOnly) {
      select.dataset.toniImgOnly = '1';
      const wrap = document.createElement('div');
      wrap.className = 'toni-swatches-img-only';
      select.parentNode.insertBefore(wrap, select.nextSibling);
      [...select.options].forEach(opt => {
        if (!opt.value) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'toni-swatch-img-btn';
        btn.style.backgroundImage = colorToSrc[opt.value] ? `url("${colorToSrc[opt.value]}")` : 'none';
        btn.setAttribute('aria-pressed', opt.selected ? 'true' : 'false');
        btn.setAttribute('title', opt.value);
        btn.addEventListener('click', () => {
          select.value = opt.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          [...wrap.querySelectorAll('.toni-swatch-img-btn')].forEach(b => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');
        });
        wrap.appendChild(btn);
      });
    }
  });
})();

/* --- Polyfills de seguridad: pauseAllMedia + trapFocus --- */
(function () {
  if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = function (root) {
      try {
        const scope = root || document;
        scope.querySelectorAll('video, audio, model-viewer').forEach(el => {
          el.pause && el.pause();
        });
      } catch (e) {}
    };
    console.debug('[TONI PATCH] polyfill window.pauseAllMedia activo');
  }
  if (typeof window.trapFocus !== 'function') {
    window.trapFocus = function(){};
  }
  if (typeof window.removeTrapFocus !== 'function') {
    window.removeTrapFocus = function(){};
  }
})();

/* ==== TONI: borde visible y sincronizado en miniaturas ==== */
(function () {
  const CSS_ID = 'toni-swatch-selected-override';
  if (!document.getElementById(CSS_ID)) {
    const st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent = `
      .product-form__input .toni-swatch-img-label,
      .variant-pills .toni-swatch-img-label,
      .product-form__input .toni-swatch-img-btn,
      .variant-pills .toni-swatch-img-btn{
        border:1.5px solid rgba(0,0,0,.28) !important;
        border-radius:999px !important;
        box-shadow:none !important;
      }
      .product-form__input .toni-swatch-img-label.toni-selected,
      .variant-pills .toni-swatch-img-label.toni-selected{
        border-color:#111 !important;
        box-shadow:0 0 0 3px #111 inset !important;
        background-clip:padding-box !important;
      }
      .product-form__input .toni-swatch-img-btn[aria-pressed="true"],
      .variant-pills .toni-swatch-img-btn[aria-pressed="true"]{
        border-color:#111 !important;
        box-shadow:0 0 0 3px #111 inset !important;
      }
      .toni-swatch-img-label:focus-visible,
      .toni-swatch-img-btn:focus-visible{
        outline:2px solid #0a84ff !important;
        outline-offset:2px !important;
      }
    `;
    document.head.appendChild(st);
  }
  function getVS(){ return document.querySelector('variant-selects'); }
  function getColorName(vs){
    const COLOR_RE = /color|colou?r|colore|couleur|farbe/i;
    const groups = [...vs.querySelectorAll('.product-form__input')];
    for (const g of groups){
      const el = g.querySelector('[name^="options["]');
      const m = el && el.name && el.name.match(/^options\[(.+)\]$/);
      if (m && COLOR_RE.test(m[1])) return m[1];
    }
    return null;
  }
  function syncBorders(){
    const vs = getVS(); if (!vs) return;
    const colorName = getColorName(vs); if (!colorName) return;
    const radios = vs.querySelectorAll(`input[type="radio"][name="options[${CSS.escape(colorName)}]"]`);
    if (radios.length){
      radios.forEach(r=>{
        const lab = vs.querySelector(`label[for="${r.id}"]`);
        if (lab) lab.classList.toggle('toni-selected', !!r.checked || lab.getAttribute('aria-checked') === 'true');
      });
    } else {
      const select = vs.querySelector(`select[name="options[${CSS.escape(colorName)}]"]`);
      if (select){
        const wrap = select.parentElement?.querySelector('.toni-swatches-img-only');
        if (wrap){
          wrap.querySelectorAll('.toni-swatch-img-btn').forEach(btn=>{
            const val = btn.getAttribute('title');
            const active = val === select.value;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }
      }
    }
  }
  document.addEventListener('change', (e)=>{
    if (!e.target || !e.target.name || !e.target.name.startsWith('options[')) return;
    syncBorders();
  }, true);
  const vs = getVS();
  if (vs){
    const mo = new MutationObserver(()=>{ syncBorders(); });
    mo.observe(vs, { subtree:true, attributes:true, attributeFilter:['checked','aria-checked','class','value'] });
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=> setTimeout(syncBorders, 0));
  } else {
    setTimeout(syncBorders, 0);
  }
  window.__TONI_swatchesSyncBorders = syncBorders;
})();
